import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import resources from '../../../services'
import Btn from '../../../ui/Btn'
import { Field } from '../../../ui/Field'
import Select from 'react-select'
import moment from 'moment'
import UpdatePage from '../../../composents/UpdatePage'

const title = 'Water cards'
const headers = {
  icon: 'feather icon-edit',
  title: title,
  description: 'update of water card',
  breadcrumbs: [
    {
      title: title,
      link: '/water_cards/digi_cards',
    },
  ],
}

export default function EditWaterCard() {
  const [loader, setLoader] = useState(false),
    [fail, setFail] = useState(false),
    [loading, setLoading] = useState(true),
    { id } = useParams(),
    [errors, setErrors] = useState({}),
    [data, setData] = useState({}),
    [user, setuser] = useState([]),
    [users, setUsers] = useState(),
    [clients, setClients] = useState([]),
    [client, setClient] = useState(),
    [permissions, setPermissions] = useState([]),
    [permission, setPermission] = useState()

  async function onGet() {
    setLoading(true)
    const response = await resources.card
      .readOne(id)
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (response.status === 200) {
      setData(response.data)
    } else if (response.status === 403) {
      setFail(true)
    }

    let cus = await resources.consumer
      .read('all')
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })

    if (cus.status === 200) {
      let a = []
      cus.data.docs.forEach((el) => {
        if (response.data?.user === el.id) {
          setuser({
            value: el.id,
            label: el.surname + '(' + el.code + ')',
            client: el.client.id,
          })
        }
        a.push({
          value: el.id,
          label: el.surname + '(' + el.code + ')',
          client: el.client.id,
        })
      })
      setUsers(a)
    }

    let ent = await resources.cardPermission
      .read('all')
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (ent.status === 200) {
      let a = []

      ent.data.docs.forEach((el) => {
        if (response.data.cardPermission === el.id) {
          setPermission({
            value: el.id,
            label: el.title,
            client: el.client?.id,
          })
        }
        a.push({
          value: el.id,
          label: el.title,
          client: el.client?.id,
        })
      })
      setPermissions(a)
    }

    let clientsFromApi = await resources.customer
      .read('all')
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (clientsFromApi.status === 200) {
      let covertaToLabelValue = []

      clientsFromApi.data.docs.forEach((el) => {
        if (response.data?.client === el.id) {
          setClient({
            value: el.id,
            label: el.name,
          })
        }
        covertaToLabelValue.push({
          value: el.id,
          label: el.name,
        })
      })
      setClients(covertaToLabelValue)
    }

    setLoading(false)
  }

  useEffect(() => {
    onGet()
  }, [])

  /**
   * @param {React.FormEvent<HTMLFormElement>} e
   */
  async function onCreate(e) {
    e.preventDefault()
    let formData = new FormData(e.target)
    let object = {}
    formData.forEach((value, key) => (object[key] = value))
    if (user) object.user = user.value
    if (permission) object.cardPermission = permission.value
    if (client) object.client = client.value
    object.cardType = data.cardType
    object.validityTo = moment(object.validityTo).format('DD-MM-YYYY')
    setLoader(true)
    setErrors({})
    let res = await resources.card
      .update(id, object)
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (res.status === 200) {
      sessionStorage.setItem('success', true)
      window.location.replace('/water_cards/digi_cards')
    } else if (res.status === 422) {
      setErrors(
        res.data.errors.reduce((acc, error) => {
          return { ...acc, [error.field]: error.message }
        }, {})
      )
    } else if (res.status === 403) {
      setErrors({ not_autorized: true })
    }
    setLoader(false)
  }

  const filterConsumer = () => {
    let all_cities = []
    if (client) {
      all_cities = users.filter((e) => e.client === client.value)
    }
    return all_cities
  }

  const filterPermission = () => {
    let all_cities = []
    if (client) {
      all_cities = permissions.filter((e) => e.client === client.value)
    }
    return all_cities
  }

  return (
    <UpdatePage
      show_error={errors['not_autorized']}
      loading={loading}
      fail={fail}
      headers={headers}
    >
      <form onSubmit={onCreate}>
        <div className="row justify-content-center mt-3 mb-3">
          <div className="col-lg-6 ">
            <div className="card">
              <div className="card-header">
                <h5>Information</h5>
              </div>
              <div className="card-body">
                <div className="mb-3">
                  <label htmlFor="exampleInputEmail1" className="form-label">
                    Customer name
                  </label>
                  <Select
                    onChange={(e) => {
                      setClient(e)
                      setPermission(null)
                      setuser(null)
                    }}
                    options={clients}
                    isSearchable
                    value={client}
                    isClearable
                    className={errors['client'] ? ' is-invalid' : ''}
                  />
                  {errors['client'] && <div className="invalid-feedback">{errors['client']}</div>}
                </div>

                <div className="form-group mb-3">
                  <label htmlFor="exampleInputEmail1" className="form-label">
                    Consumer name
                  </label>
                  <Select
                    onChange={setuser}
                    options={filterConsumer()}
                    isSearchable
                    isClearable
                    value={user}
                    className={errors['user'] ? ' is-invalid' : ''}
                  />
                  {errors['user'] && <div className="invalid-feedback">{errors['user']}</div>}
                </div>

                <div className="form-group mb-3">
                  <label htmlFor="exampleInputEmail1" className="form-label">
                    Permissions
                  </label>
                  <Select
                    onChange={setPermission}
                    options={filterPermission()}
                    isSearchable
                    isClearable
                    value={permission}
                    className={errors['cardPermission'] ? ' is-invalid' : ''}
                  />
                  {errors['cardPermission'] && (
                    <div className="invalid-feedback">{errors['cardPermission']}</div>
                  )}
                </div>

                <Field
                  name="cardId"
                  className="mb-3"
                  error={errors['cardId']}
                  defaultValue={data.cardId}
                  required
                >
                  Card id
                </Field>

                <Field
                  name="validityTo"
                  className="mb-3"
                  error={errors['validityTo']}
                  type="date"
                  defaultValue={moment(data.validityTo).format('YYYY-MM-DD')}
                  required
                >
                  card validity
                </Field>

                <Field
                  name="description"
                  type="textarea"
                  error={errors['description']}
                  defaultValue={data.description}
                  className="mb-3"
                >
                  Note
                </Field>

                <div className="row ">
                  <div className="col-lg-12">
                    <div className="d-grid gap-2">
                      <Btn class="btn waves-effect waves-light btn-primary" onLoad={loader}>
                        <i className="feather icon-save"></i> Submit
                      </Btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </UpdatePage>
  )
}
